import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Spellgroup from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface SpellgroupState extends ListState<Spellgroup> {
    editSpellgroup: Spellgroup;
    orderno: string;
    total: '';
    shopid: '';
    paynum: number;
}
class SpellgroupModule extends ListModule<SpellgroupState, any, Spellgroup> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Spellgroup>(),
        loading: false,
        editTemplate: new Spellgroup(),
    };
    public actions = {
        async getAll(context: ActionContext<SpellgroupState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/Pintuan/GetPintuanList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Spellgroup>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getDetail(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Pintuan/GetPintuanDetail?id=' + payload.data.id +
                '&itemno=' + payload.data.itemno + '&parentno=' + (payload.data.parentno ? payload.data.parentno : ''));
            return reponse.data.result as Spellgroup;
        },
        async getGroupDetail(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Pintuan/PintuanOrder',payload.data);
            return reponse.data.result as Spellgroup;
        },
        async getGroupList(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Pintuan/PintuanOrderList',payload.data);
            return reponse.data.result as Spellgroup;
        },
        async getPintuanConfirmDetail(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Pintuan/GetPintuanConfirmDetail?id=' + payload.data.id +
                '&itemno=' + payload.data.itemno + '&parentno=' + (payload.data.parentno ? payload.data.parentno : ''));
            return reponse.data.result as Spellgroup;
        },
        async addOrder(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Pintuan/AddPintuanOrder', payload.data);
            const result = reponse.data.result;
            context.state.orderno = result.data.orderno;
            context.state.total = result.data.total;
            context.state.shopid = result.data.shopid;
            return reponse.data.result;
        },
        async getPintuanSupportPayWay(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Pintuan/GetPintuanSupportPayWay?orderno=' + payload.data.orderno);
            return reponse.data.result;
        }, 
        //获取分享海报
        async getSharePicDetail(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/t_item_info/ItemInfoPoster', payload.data);
            return reponse.data.result;
        }, 
        //获取商品分享二维码
        async getShareQrcode(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/CodeManagementService/CreateQrCode', payload.data);
            return reponse.data.result;
        }, 
        async checkUserTakePartStatus(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Pintuan/CheckUserTakePartStatus?id=' + payload.data.id +
            '&itemno=' + payload.data.itemno + '&parentno=' + (payload.data.parentno ? payload.data.parentno : ''));
            return reponse.data.result;
        },
        //活动隔离，拼团
        // async getDetail_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
        //     const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetPintuanDetail?id=' + payload.data.id +
        //         '&itemno=' + payload.data.itemno + '&parentno=' + (payload.data.parentno ? payload.data.parentno : ''));
        //     return reponse.data.result as Spellgroup;
        // },
        async getDetail_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/promotion/offer-service/app/activity/getPinTuanProductDetail', payload.data);
            return reponse.data.dataInfo;
        },
         //活动隔离，拼团
         async addOrder_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobilePintuan/AddPintuanOrder', payload.data);
            console.log(reponse);
            const result = reponse.data.result;
            context.state.orderno = result.orderno;
            context.state.total = result.total;
            context.state.shopid = result.shopid;
            return reponse.data.result;
        },
         //活动隔离，拼团
        async getPintuanConfirmDetail_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetPintuanConfirmDetail?id=' + payload.data.id +
                '&itemno=' + payload.data.itemno + '&parentno=' + (payload.data.parentno ? payload.data.parentno : ''));
            return reponse.data.result as Spellgroup;
        },
        //活动隔离，拼团
        async getAll_Mobile(context: ActionContext<SpellgroupState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetPintuanList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Spellgroup>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        // //活动隔离-拼团
        // async addOrder_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
        //     const reponse = await Ajax.post('/api/services/app/MobilePintuan/AddOrder', payload.data);
        //     const result = reponse.data.result;
        //     context.state.orderno = result.orderno;
        //     context.state.total = result.total;
        //     context.state.shopid = result.shopid;
        //     return reponse.data.result;
        // },
        //活动隔离-拼团
        async getConfirmOrderDetail_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobilePintuan/GetConfirmOrderDetail', payload.data);
            return reponse.data.result;
        },
        //活动隔离-拼团
        async voucherforuselist_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobilePintuan/VoucherForUseList', payload.data);
            return reponse.data.result;
        },
        //活动隔离-拼团
        async checkStockFromOffline_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobilePintuan/CheckStockFromOffline', payload.data);
            return reponse.data.result;
        },
         //活动隔离-拼团
        async checkUserTakePartStatus_MobilePintuan(context: ActionContext<SpellgroupState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/CheckUserTakePartStatus?id=' + payload.data.id +
            '&itemno=' + payload.data.itemno + '&parentno=' + (payload.data.parentno ? payload.data.parentno : ''));
            return reponse.data.result;
        },
    };
    public mutations = {
        setCurrentPage(state: SpellgroupState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SpellgroupState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: SpellgroupState, Spellgroup: Spellgroup) {
            state.editSpellgroup = Spellgroup;
        },
    };
}
const spellgroupModule = new SpellgroupModule();
export default spellgroupModule;
